"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var queryable_1 = require("./queryable");
var Subscriptions = (function (_super) {
    __extends(Subscriptions, _super);
    function Subscriptions(baseUrl, path) {
        if (path === void 0) { path = "subscriptions"; }
        _super.call(this, baseUrl, path);
    }
    Subscriptions.prototype.getById = function (subscriptionId) {
        var subscription = new Subscription(this);
        subscription.concat("('" + subscriptionId + "')");
        return subscription;
    };
    Subscriptions.prototype.add = function (notificationUrl, expirationDate, clientState) {
        var _this = this;
        var postBody = JSON.stringify({
            "resource": this.toUrl(),
            "notificationUrl": notificationUrl,
            "expirationDateTime": expirationDate,
            "clientState": clientState || "pnp-js-core-subscription",
        });
        return this.post({ body: postBody, headers: { "Content-Type": "application/json" } }).then(function (result) {
            return { data: result, subscription: _this.getById(result.id) };
        });
    };
    return Subscriptions;
}(queryable_1.QueryableCollection));
exports.Subscriptions = Subscriptions;
var Subscription = (function (_super) {
    __extends(Subscription, _super);
    function Subscription(baseUrl, path) {
        _super.call(this, baseUrl, path);
    }
    Subscription.prototype.update = function (expirationDate) {
        var _this = this;
        var postBody = JSON.stringify({
            "expirationDateTime": expirationDate,
        });
        return this.patch({ body: postBody, headers: { "Content-Type": "application/json" } }).then(function (data) {
            return { data: data, subscription: _this };
        });
    };
    Subscription.prototype.delete = function () {
        return _super.prototype.delete.call(this);
    };
    return Subscription;
}(queryable_1.QueryableInstance));
exports.Subscription = Subscription;
